/**
 * created by lei lei on 2021/3/11
 * 系统日志
 */
import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName()+'/';
const Apis = {
    visitLog: host + 'visitLog/list',//用户访问日志
};

//用户访问日志
export const visitLog = (body,callBack) => {
    request({url:Apis.visitLog, body, callBack});
};



